/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import MediumRegistry from '../../../core/medium/medium-registry';

/**
 * @import { ViewerRegistry as IViewerRegistry } from '../../../core/viewer/registry/'
 * @import { ViewerType } from '../../../core/viewer/type/'
 */

/**
 * Registr informací o typech médií pro standardní webové technologie.
 * Podporuje všechny obrázky, videa a weby.
 * @implements {IViewerRegistry}
 */
export default class ViewerRegistry {
  /**
   * Vytvoří instanci.
   * @param {ViewerType} imageType Záznam registru pro obrázky.
   * @param {ViewerType} kioskType Záznam registru pro kiosky.
   * @param {ViewerType} pdfType Záznam registru pro Pdf.
   * @param {ViewerType} streamType Záznam registru pro stream.
   * @param {ViewerType} videoType Záznam registru pro videa.
   * @param {ViewerType} webType Záznam registru pro web.
   * @param {ViewerType} widgetType Záznam registru pro widgety.
   */
  constructor(
    imageType,
    kioskType,
    pdfType,
    streamType,
    videoType,
    webType,
    widgetType
  ) {
    // Vytvoření nového registru.
    /** @type {MediumRegistry<ViewerType>} */
    const mediumRegistry = new MediumRegistry();
    // Registrace záznamů registru.
    mediumRegistry.register('image/*', imageType);
    mediumRegistry.register('application/pdf', pdfType);
    mediumRegistry.register('application/x-http-stream', streamType);
    mediumRegistry.register('application/x-kiwi-kiosk-1', kioskType);
    mediumRegistry.register('video/*', videoType);
    mediumRegistry.register('text/html', webType);
    mediumRegistry.register('application/x-kiwi-web-1', widgetType);
    this.mediumRegistry = mediumRegistry;
  }

  /** @type {IViewerRegistry['find']} */
  find(mediumType) {
    return this.mediumRegistry.find(mediumType);
  }

  /** @type {IViewerRegistry['getAll']} */
  getAll() {
    return this.mediumRegistry.getAll();
  }
}
